import { CrudEndpoint } from './crud.endpoint';

export class BulkCampaignsEndpoint extends CrudEndpoint {
	constructor() {
		super('bulk-campaigns');
	}
}
